import React from 'react'

export const RowCheck = React.forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper props type
  ({ indeterminate, ...rest }: any, ref) => {
    const defaultRef = React.useRef()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper ref type
    const resolvedRef: any = ref || defaultRef

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    )
  },
)

RowCheck.displayName = 'RowCheck'
